import React, { useState } from 'react';
import Email from '../assets/email.svg';

import './Footer.css'


export default function Footer() {

    const [year] = useState(new Date().getFullYear());



    return (
        <div className='footer'>


        <div className="contact" id="contact">
            <a href="mailto:benhove86@gmail.com" target='_blank' rel="noreferrer"><img src={Email} alt="email" /></a>   
        </div>
<div className='credits'>
<p>© {year} Benjamin Hove</p>
</div>
        

       

       
         
           
        </div>
    )
}